import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as CoreActions from '@app/core/store/core.action';
import { ActivatedRoute } from "@angular/router";
import { Store } from '@ngrx/store';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { selectCoreState, selectMeState } from '@app/core/store/core.selectors';
import { SubSink } from 'subsink';
import { skipWhile, BehaviorSubject } from 'rxjs';
import { LimitAccessService } from '@app/core/services/limit-access.service';

export const locName$: BehaviorSubject<string> = new BehaviorSubject<string>(null);

@Component({
    selector: 'app-branding',
    templateUrl: './branding.component.html',
    styleUrls: ['./branding.component.scss'],

})

export class BrandingComponent implements OnInit {
    public form: FormGroup;
    public subs$: SubSink = new SubSink();
    public id$: number;
    public user: any;
    public logoSiteOption: boolean = false;
    public logoReportOption: boolean = false;

    constructor(
        private _store: Store,
        public _route: ActivatedRoute,
        private limitAccessService: LimitAccessService
    ) {
        this._store.dispatch(CoreActions.setTitle({ title: this._route.snapshot.data['title'] }));
        this.form = new FormGroup({
            locName: new FormControl('', Validators.required)
        });

        this.subs$.add(this._store.select(selectMeState).pipe(
            skipWhile(res => res == null),
        ).subscribe(({ locName, locID }) => {
            this.id$ = locID;
            this.form.controls['locName'].setValue(locName);
            locName$.next(this.form.value.locName);
        }));
    }

    ngOnInit() {
        this.limitAccessService.arraySettingAccess$.subscribe((arraySettingAccess) => {
            if (arraySettingAccess) {
              let resultLogoSite = this.limitAccessService.getAccess('administration', 'branding', 'logo_site','');
              let resultLogoReport = this.limitAccessService.getAccess('administration', 'branding', 'logo_report','');
              this.logoSiteOption=resultLogoSite;
              this.logoReportOption=resultLogoReport;
            }
          });
    }

    onSubmit() {
        this._store.dispatch(CoreActions.updateLocation({ form: this.form.value, id: this.id$ }))
        locName$.next(this.form.value.locName);
    }

    

}
